module.exports = __webpack_public_path__ + "img/bit-coin-fill.f5544577.svg";